import { ActionGroup } from "@mittwald/flow-remote-react-components";
import { Button } from "@mittwald/flow-remote-react-components";
import { Content } from "@mittwald/flow-remote-react-components";
import { Heading } from "@mittwald/flow-remote-react-components";
import { Modal } from "@mittwald/flow-remote-react-components";
import { Text } from "@mittwald/flow-remote-react-components";
import { useDeleteDirectoryProtection } from "../../hooks/useDeleteDirectoryProtection";
import { OverlayController } from "@mittwald/flow-remote-react-components";

export const DeleteDirectoryProtectionModal = (props: {
  path: string;
  appInstallationDescription: string;
  appInstallationId: string;
  projectId: string;
  controller: OverlayController;
}) => {
  const deleteDirectoryProtectionMutation = useDeleteDirectoryProtection(
    props.projectId,
  );

  return (
    <Modal size="s" controller={props.controller}>
      <Heading>Passwortschutz löschen</Heading>
      <Content>
        <Text>
          Möchtest du den Passwortschutz für das Verzeichnis{" "}
          <strong>{props.path}</strong> in der App{" "}
          <strong>{props.appInstallationDescription}</strong> wirklich löschen?
        </Text>
      </Content>
      <ActionGroup>
        <Button
          color="danger"
          isPending={deleteDirectoryProtectionMutation.isPending}
          isSucceeded={deleteDirectoryProtectionMutation.isSuccess}
          onPress={() => {
            void deleteDirectoryProtectionMutation
              .mutateAsync({
                appInstallationId: props.appInstallationId,
                path: props.path,
              })
              .then(() => {
                props.controller.close();
                deleteDirectoryProtectionMutation.reset();
              });
          }}
        >
          Passwortschutz löschen
        </Button>
        <Button
          color="secondary"
          variant="soft"
          onPress={() => {
            props.controller.close();
          }}
        >
          Abbrechen
        </Button>
      </ActionGroup>
    </Modal>
  );
};
